// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-module--banner--2vF4R","title":"Banner-module--title--1ca0B"};